var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('grain',{attrs:{"height":_vm.height,"width":_vm.width,"type":"water"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }